import classNames from 'classnames';

import defaultLogo from './defaultLogo.svg';

import './DefaultLogo.scss';

const DEFAULT_SIZE = 'medium';

type DefaultLogoProps = {
  size?: string;
  className?: string;
};

const DefaultLogo = ({ size = DEFAULT_SIZE, className }: DefaultLogoProps) => {
  const logoSizeClass = `DefaultLogo--${size}`;
  const logoClassName = classNames(
    'DefaultLogo',
    { [logoSizeClass]: !!size },
    className,
  );

  return (
    <img
      className={logoClassName}
      src={defaultLogo}
      alt="Flywire"
      fetchpriority="high"
      loading="eager"
    />
  );
};

export { DefaultLogo };
